import axios from 'axios';
import Vue from 'vue'

export default {
    findBcFrsSupplier(page, pageSize, type, partnerCode) {
        return axios.get('/api/bc-supplier/list', { params: { page: page, pageSize: pageSize, type: type, partnerCode: partnerCode } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

